export enum SelectionValueType {
    SIMPLE = 'Simple',
    ITEM = 'Item',
}
